import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import * as S from './styles';

// Appears only once the hero has scrolled away, so the opening image stays whole.
function Header() {
  const [stuck, setStuck] = useState(false);

  useEffect(() => {
    const onScroll = () => setStuck(window.scrollY > window.innerHeight * 0.72);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <S.Bar $stuck={stuck} aria-hidden={!stuck}>
      <S.Inner>
        <S.Mark href="#top">
          Spedine <span>Studio</span>
        </S.Mark>
        <S.Nav>
          <a href="#politica">
            <FormattedMessage id="nav.policy" />
          </a>
          <a href="#precos">
            <FormattedMessage id="nav.prices" />
          </a>
          <a href="#estudio">
            <FormattedMessage id="nav.studio" />
          </a>
        </S.Nav>
      </S.Inner>
    </S.Bar>
  );
}

export default Header;
